;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.5";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  release: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
  environment: process.env.NEXT_PUBLIC_VERCEL_ENV,

  enabled: process.env.NODE_ENV === "production",

  integrations: [Sentry.browserTracingIntegration()],

  tracesSampleRate: 0.02,

  ignoreErrors: [
    /*
     * This is not an actual error, and there doesn't seem to be any other way
     * to suppress that.
     *
     * See https://forum.sentry.io/t/resizeobserver-loop-limit-exceeded/8402/5
     */
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications.",

    /*
     * See https://github.com/getsentry/sentry-javascript/issues/3440#issuecomment-954602174
     */
    "Non-Error promise rejection captured",

    /*
     * May be because we're somehow misusing Next.js links, or a bug in Next.js.
     *
     * Check if this error still appears after we upgrade Next.js to v14 or later.
     */
    /Invariant: attempted to hard navigate to the same URL/,

    /*
     * We only support modern browsers, but somebody with Chrome 84 (released July 14, 2020)
     * keeps accessing the website.
     */
    /requestAnimationFrame is not defined/,
  ],

  beforeSend(event, hint) {
    /*
     * Oh Google…
     *
     * See https://github.com/getsentry/sentry-javascript/issues/2514#issuecomment-603971338
     */
    if (hint?.originalException === "Timeout") {
      return null;
    }

    return event;
  },

  denyUrls: [/cyp\.jobbase\.io\//i, /fast\.wistia\.com\//i],
});

// export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
